export enum UsersActionType {
  SET_USERS = 'SET_USERS',
  SEARCH_USER = 'SEARCH_USER',
  SET_PAGINATION = 'SET_PAGINATION',
  SET_USERS_AFTER_SCROLL = 'SET_USERS_AFTER_SCROLL',
  SET_CERTAIN_USER = 'SET_CERTAIN_USER',
  SET_USERS_LOADING_STATUS = 'SET_USERS_LOADING_STATUS',
}
